<script setup lang="ts">
import {
  computed, ref, onMounted, watch,
} from "vue";
import type {
  Locale,
} from "~/stores/locale";
import {
  useApiFetch,
} from "~/composables/useApiFetch";

const props = defineProps<{
  modelValue?: Locale;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: Locale): void;
  (e: "loaded", data: {version: string; language: Locale}): void;
}>();

const selectedLanguageLocal = ref<Locale>("de");
const selectedLanguage = computed({
  get() {
    return props.modelValue || selectedLanguageLocal.value;
  },
  set(val: Locale) {
    selectedLanguageLocal.value = val;
    emit("update:modelValue", val);
  },
});

const content = ref<string>("");
const loading = ref<boolean>(false);

const apiFetch = useApiFetch();

const fetchPrivacy = async () => {
  loading.value = true;
  try {
    const res = await apiFetch<{content: string; version: string; language: Locale} | null>(
      `/agreements/privacy-policy?lang=${selectedLanguage.value}`,
    );
    content.value = res?.content || "";
    if (res) {
      emit("loaded", {version: res.version, language: res.language});
    }
  } catch (error) {
    console.error("Failed to fetch privacy policy:", error);
  } finally {
    loading.value = false;
  }
};

watch(selectedLanguage, fetchPrivacy);

onMounted(fetchPrivacy);
</script>

<template>
  <div class="relative w-full">
    <div class="flex justify-end p-1">
      <language-switcher v-model="selectedLanguage" />
    </div>

    <agreement-content
      v-loading="loading"
      :content="content"
    />
  </div>
</template>
